import styled from 'styled-components';
import { ReactComponent as RawArrowUpwardSVG } from '../../../../assets/icons/icon_arrow_upward.svg';

export const IconArrowUpward = styled(RawArrowUpwardSVG)``;
